import * as React from 'react';
import classnames from 'classnames';

import BarChartProgress from 'components/graphs/bar-chart-progress/BarChartProgress';

import { getMetricTypeWidth } from 'modules/reporting/utils/reporting-task-types';
import { __t, applyTranslations } from 'utils/language';

import type { BarChartProgressItem } from 'types';

import './creator-task-progress-widget.scss';

applyTranslations(require('./creator-task-progress-widget.i18n.json'));

type Props = {
  creatorBarChartItems: Array<BarChartProgressItem>,
  taskProgressBarChartItems: Array<BarChartProgressItem>,
  hideCreators?: boolean,
  isLoading: boolean
};

class CreatorTaskProgressWidget extends React.Component<Props> {
  render() {
    const { creatorBarChartItems, taskProgressBarChartItems, hideCreators, isLoading } = this.props;
    const metricType = getMetricTypeWidth([...creatorBarChartItems, ...taskProgressBarChartItems]);
    const classses = classnames('creator-task-progress-widget', {
      'creator-task-progress-widget--single': hideCreators
    });

    return (
      <div className={classses}>
        {
          !hideCreators && (
            <BarChartProgress
              data={creatorBarChartItems}
              title={__t('creator_task_progress_widget.creator_title_label')}
              barStyle={{
                title: { marginBottom: 16 },
                container: { marginBottom: 16 }
              }}
              hasMinHeight={false}
              isLoading={isLoading}
              emptyMessageWrapperClass="creator-task-progress-widget__empty-message"
              metricContainerType={metricType}
            />
          )
        }
        <div className="creator-task-progress-widget__task-progress-container">
          <BarChartProgress
            data={taskProgressBarChartItems}
            title={__t('creator_task_progress_widget.task_progress_label')}
            barStyle={{
              title: { marginBottom: hideCreators ? 26 : 16 },
              container: { marginBottom: 16 }
            }}
            hasMinHeight={false}
            isLoading={isLoading}
            emptyMessageWrapperClass="creator-task-progress-widget__empty-message"
            metricContainerType={metricType}
          />
        </div>
      </div>
    );
  }
}

export default CreatorTaskProgressWidget;
